import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './component/Header';
import HeroSection from './component/HeroSlider';
import HomeContactAndFooter from './component/HomeContactAndFooter';
import AboutSection from './pages/AboutSection';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ServiceSection from './pages/ServiceSection';
import Ourfleet from './pages/GuideSection';
import Packages from './pages/Packages';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import ContactSection from './pages/ContactSection';
import Enquiry from './pages/Enquiry';
import Innovacabonrentinhadapsar from './pages/Innova Cab on Rent in Hadapsar Pune';
import ScrollToTop from './component/ScrollToTop';
import Punetopanchganicabs from './pages/Pune to Panchgani Cab';
import Punetogoacabs from './pages/Pune to Goa Cab';
import Punetobhimashankar from './pages/Pune to Bhimashankar Cab';
import Punetoshirdicabs from './pages/Pune to Shirdi Cab';
import Punetoashtavinayakcabs from './pages/Pune to Ashtavinayak Cab';
import Punetonashikacabs from './pages/Pune to Nashik Cab';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Punetomumbaiairport from './pages/Pune to Mumbai Airport Cab';
import Punetoaurangabadcab from './pages/Pune to Aurangabad Cab';
import Punetoajantaellora from './pages/Pune to Ajanta Ellora Tour Package';
import Punetokolhapurcab from './pages/Pune to Kolhapur Cab';
import Punetoimagicacab from './pages/Pune to Imagica Cab';
import Punetoahmednagarcabs from './pages/Pune to Ahmednagar Cab';
import Punetokonkandarshan from './pages/Pune to Konkan Darshan Cab';
import Punetosanglicabs from './pages/Pune to Sangli Cab';
import Punetolonavalataxi from './pages/Pune to Lonavala Taxi';
import Punetoalibauginnovacabs from './pages/Pune to Alibaug Innova Cab';
import Punetosolapurtaxi from './pages/Pune to Solapur Taxi';
import Cabserviceinpune from './pages/Cab Service in Pune';
import Innovaperkmrateforoutstation from './pages/Innova Per Km Rate for Outstation';
import Punetolavasacabs from './pages/Pune to Lavasa Cab';
import Punetomatherancabs from './pages/Pune to Matheran Cab';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Taxiservicenearme from './pages/Taxi Service Near Me';
import Innovacabs from './pages/Innova Cabs';
import Innovacrystacabooking from './pages/Innova Crysta Cab Booking';
import Punetomumbaiinnovacabs from './pages/Pune to Mumbai Innova Cab';
import Bookinnovacrystaforoutstaion from './pages/Book Innova Crysta for Outstation';
import Innovacrystacabpune from './pages/Innova Crysta Cab Pune';
import Innovacrystataxi from './pages/Innova Crysta Taxi';
import Innovacabforweddinginpune from './pages/Innova Cab for Wedding in Pune';
import Punetomahabaleshwarinnova from './pages/Pune to Mahabaleshwar Innova Cab';
import Punetoshirdiinnovabooking from './pages/Pune to Shirdi Innova Cab Booking';
import Punetomumbaiairportinovacab from './pages/Pune to Mumbai Airport Innova Cab';
import Punetogoainnovacab from './pages/Pune to Goa Innova Cab';
import Punetoashtavinayakinnovatourpackages from './pages/Pune to Ashtavinayak Innova Tour Package';
import Sedancabserviceinpune from './pages/Sedan Cab Service in Pune';
import Etioscabforoutstationinpune from './pages/Etios Cab for Outstation in Pune';
import Toyotaetioncabbookinginpune from './pages/Toyota Etios Cab Booking in Pune';
import Swiftdzireonrentpune from './pages/Swift Dzire on Rent Pune';
import Punetoshirdiswiftdzire from './pages/Pune to Shirdi Swift Dzire Cab';
import Punetomahabaleshwarswift from './pages/Pune to Mahabaleshwar Swift Dzire Cabs';
import Punetomumbaidzirecab from './pages/Pune to Mumbai Dzire Cab';
import Punetogujratcab from './pages/Pune to Gujarat Cab';
import Punetorajshtan from './pages/Pune to Rajasthan Cab';
import Punetoindorecabbooking from './pages/Pune to Indore Cab Booking';
import Punetovijayawadacab from './pages/Pune to Vijayawada Cabs';
import Punetobanglorecab from './pages/Pune to Bangalore Cab';
import Punetohyderabadcab from './pages/Pune to Hyderabad Cab';
import Punetobelgaumcab from './pages/Pune to Belgaum Cab';
import Sevanseatercaronrent from './pages/7 Seater Car On Rent in Pune';
import Punetomumbaiinternatinalairport from './pages/Pune to Mumbai International Airport Cab';
import Punetomumbaionewaycab from './pages/Pune to Mumbai One Way Cab';
import Punetomumbaitaxifare from './pages/Pune to Mumbai Taxi Fare';
import Kiacarenceonrentinpune from './pages/Kia Carens On Rent in Pune';
import Sedancabsbookinginpune from './pages/Sedan Cabs Booking in Pune';
import Punestationtomumbaicabs from './pages/Pune Station to Mumbai Cabs Service';
import Vimannagartomumbaicabs from './pages/Viman Nagar to Mumbai Cabs';
import Kondhwatomumbaicab from './pages/Kondhwa to Mumbai Cab';
import Kharaditomumbaicabs from './pages/Kharadi to Mumbai Cab';
import Koregaonparktomumbaicab from './pages/Koregaon Park to Mumbai Cab';
import Kalyaninagartomumbaitaxi from './pages/Kalyani Nagar to Mumbai Taxi';
import Wakadtomumbaicab from './pages/Wakad to Mumbai Cab';
import Wagholitomumbaicab from './pages/Wagholi to Mumbai Cab';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent in Pune';
import Ertigacabbookinginpune from './pages/Ertiga Cab Booking in Pune';
import Cabbookingforweddinginpune from './pages/Cab booking for wedding in Pune';
import Cabbookingformarriagefunction from './pages/Cab Booking for Marriage function in Pune';
import Ertigaonrentinhinjewadi from './pages/Ertiga on Rent in Hinjewadi';
import Punetomumbaiertigaonrent from './pages/Pune to Mumbai Ertiga On rent';
import Ertigaonrentinpune from './pages/Ertiga on Rent in Pune';
import Punetogiaertigaonrent from './pages/Pune to goa Ertiga on rent';
import Punetomahabaleshwarertiga from './pages/Pune To mahabaleshwar Ertiga On rent';
import Hadapsartomumbaicab from './pages/Hadapsar to Mumbai Cab';
import Alanditomumbaicabsservice from './pages/Alandi to Mumbai Cabs Service';
import Onewaytaxipunetomumbai from './pages/One Way Taxi Pune to Mumbai';
import Mumbaidarshancabs from './pages/Mumbai Darshan Cabs';
import Punetofivejyotilinga from './pages/Pune to 5 Jyotirlinga Cab';
import Vimannagartomumbaiertigaonrent from './pages/Viman Nagar to Mumbai Ertiga On rent';
import Puneoutstationcabs from './pages/Pune Outstation Cabs';
import Punetomahabaleshwar from './pages/Pune to Mahabaleshwar Cab';
import ContactButtons from './component/ContactButtons';
import Punesadeteenshaktipeeth from './pages/Pune Sade Teen Shakti Peeth Bus on Rent';
function App() {




  return (
    <Router>
      <Header/>
     <ContactButtons/>
      <ScrollToTop/>

      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<ServiceSection />} />
        <Route path="/our-fleet" element={<Ourfleet />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/pune-to-mahabaleshwar-cab" element={<Punetomahabaleshwar />} />

<Route path="/pune-to-panchgani-cab" element={<Punetopanchganicabs />} />
<Route path="/pune-to-goa-cab" element={<Punetogoacabs />} />
<Route path="/pune-to-bhimashankar-cab" element={<Punetobhimashankar />} />
<Route path="/pune-to-shirdi-cab" element={<Punetoshirdicabs />} />
<Route path="/pune-to-ashtavinayak-cab" element={<Punetoashtavinayakcabs />} />
<Route path="/pune-to-nashik-cab" element={<Punetonashikacabs />} />
<Route path="/pune-to-mumbai-cabs" element={<Punetomumbaicabs />} />
<Route path="/pune-to-mumbai-airport-cab" element={<Punetomumbaiairport />} />
<Route path="/pune-to-aurangabad-cab" element={<Punetoaurangabadcab />} />
<Route path="/pune-to-ajanta-ellora-tour-package" element={<Punetoajantaellora />} />
<Route path="/pune-to-kolhapur-cab" element={<Punetokolhapurcab />} />
<Route path="/pune-to-imagica-cab" element={<Punetoimagicacab />} />
<Route path="/pune-to-ahmednagar-cab" element={<Punetoahmednagarcabs />} />
<Route path="/pune-to-konkan-darshan-cab" element={<Punetokonkandarshan />} />
<Route path="/pune-to-sangli-cab" element={<Punetosanglicabs />} />
<Route path="/pune-to-lonavala-taxi" element={<Punetolonavalataxi />} />
<Route path="/pune-to-alibaug-innova-cab" element={<Punetoalibauginnovacabs />} />
<Route path="/pune-to-solapur-taxi" element={<Punetosolapurtaxi />} />
<Route path="/cab-service-in-pune" element={<Cabserviceinpune />} />
<Route path="/pune-to-outstation-cab" element={<Innovaperkmrateforoutstation />} />
<Route path="/pune-to-lavasa-cab" element={<Punetolavasacabs />} />
<Route path="/pune-to-matheran-cab" element={<Punetomatherancabs />} />
<Route path="/online-cab-booking-pune" element={<Onlinecabbookingpune />} />
<Route path="/pune-sade-teen-shakti-peeth-cab-on-rent" element={<Punesadeteenshaktipeeth />} />
<Route path="/taxi-service-near-me" element={<Taxiservicenearme />} />
{/* <Route path="/taxi-service-near-me" element={<Cabserviceinpune />} /> */}


<Route path="/innova-per-km-rate-for-outstation" element={<Innovaperkmrateforoutstation />} />
<Route path="/innova-cabs" element={<Innovacabs />} />
<Route path="/innova-crysta-cab-booking" element={<Innovacrystacabooking />} />
<Route path="/pune-to-mumbai-innova-cab" element={<Punetomumbaiinnovacabs />} />
<Route path="/book-innova-crysta-for-outstation" element={<Bookinnovacrystaforoutstaion />} />
<Route path="/innova-crysta-cab-pune" element={<Innovacrystacabpune />} />
<Route path="/innova-crysta-taxi" element={<Innovacrystataxi />} />
<Route path="/innova-cab-for-wedding-in-pune" element={<Innovacabforweddinginpune />} />
<Route path="/innova-cab-on-rent-in-hadapsar-pune" element={<Innovacabonrentinhadapsar />} />
<Route path="/pune-to-mahabaleshwar-innova-cab" element={<Punetomahabaleshwarinnova />} />
<Route path="/pune-to-shirdi-innova-cab-booking" element={<Punetoshirdiinnovabooking />} />
<Route path="/pune-to-mumbai-airport-innova-cab" element={<Punetomumbaiairportinovacab />} />
<Route path="/pune-to-goa-innova-cab" element={<Punetogoainnovacab />} />
<Route path="/pune-to-ashtavinayak-innova-tour-package" element={<Punetoashtavinayakinnovatourpackages />} />
<Route path="/sedan-cab-service-in-pune" element={<Sedancabserviceinpune />} />
<Route path="/etios-cab-for-outstation-in-pune" element={<Etioscabforoutstationinpune />} />
<Route path="/toyota-etios-cab-booking-in-pune" element={<Toyotaetioncabbookinginpune />} />
<Route path="/swift-dzire-on-rent-pune" element={<Swiftdzireonrentpune />} />
<Route path="/pune-to-shirdi-swift-dzire-cab" element={<Punetoshirdiswiftdzire />} />
<Route path="/pune-to-mahabaleshwar-swift-dzire-cabs" element={<Punetomahabaleshwarswift />} />
<Route path="/pune-to-mumbai-dzire-cab" element={<Punetomumbaidzirecab />} />
<Route path="/pune-to-gujarat-cab" element={<Punetogujratcab />} />
<Route path="/pune-to-rajasthan-cab" element={<Punetorajshtan />} />
<Route path="/pune-to-indore-cab-booking" element={<Punetoindorecabbooking />} />
<Route path="/pune-to-vijayawada-cabs" element={<Punetovijayawadacab />} />
<Route path="/pune-to-bangalore-cab" element={<Punetobanglorecab />} />
<Route path="/pune-to-hyderabad-cab" element={<Punetohyderabadcab />} />
<Route path="/pune-to-belgaum-cab" element={<Punetobelgaumcab />} />

<Route path="/7-seater-car-on-rent-in-pune" element={<Sevanseatercaronrent />} />
<Route path="/pune-to-mumbai-international-airport-cab" element={<Punetomumbaiinternatinalairport />} />
<Route path="/pune-to-mumbai-one-way-cab" element={<Punetomumbaionewaycab />} />
<Route path="/pune-to-mumbai-taxi-fare" element={<Punetomumbaitaxifare />} />
<Route path="/kia-carens-on-rent-in-pune" element={<Kiacarenceonrentinpune />} />
<Route path="/sedan-cabs-booking-in-pune" element={<Sedancabsbookinginpune />} />
<Route path="/pune-station-to-mumbai-cabs-service" element={<Punestationtomumbaicabs />} />
<Route path="/viman-nagar-to-mumbai-cabs" element={<Vimannagartomumbaicabs />} />
<Route path="/kondhwa-to-mumbai-cab" element={<Kondhwatomumbaicab />} />
<Route path="/kharadi-to-mumbai-cab" element={<Kharaditomumbaicabs />} />
<Route path="/koregaon-park-to-mumbai-cab" element={<Koregaonparktomumbaicab />} />
<Route path="/kalyani-nagar-to-mumbai-taxi" element={<Kalyaninagartomumbaitaxi />} />
<Route path="/wakad-to-mumbai-cab" element={<Wakadtomumbaicab />} />
<Route path="/wagholi-to-mumbai-cab" element={<Wagholitomumbaicab />} />
<Route path="/swift-dzire-on-rent-in-pune" element={<Swiftdzireonrentinpune />} />
<Route path="/ertiga-cab-booking-in-pune" element={<Ertigacabbookinginpune />} />
<Route path="/cab-booking-for-wedding-in-pune" element={<Cabbookingforweddinginpune />} />
<Route path="/cab-booking-for-marriage-function-in-pune" element={<Cabbookingformarriagefunction />} />
<Route path="/ertiga-on-rent-in-hinjewadi" element={<Ertigaonrentinhinjewadi />} />
<Route path="/pune-to-mumbai-ertiga-on-rent" element={<Punetomumbaiertigaonrent />} />
<Route path="/ertiga-on-rent-in-pune" element={<Ertigaonrentinpune />} />
<Route path="/pune-to-goa-ertiga-on-rent" element={<Punetogiaertigaonrent />} />
<Route path="/pune-to-mahabaleshwar-ertiga-on-rent" element={<Punetomahabaleshwarertiga />} />
<Route path="/hadapsar-to-mumbai-cab" element={<Hadapsartomumbaicab />} />
<Route path="/alandi-to-mumbai-cabs-service" element={<Alanditomumbaicabsservice />} />
<Route path="/one-way-taxi-pune-to-mumbai" element={<Onewaytaxipunetomumbai />} />
<Route path="/mumbai-darshan-cabs" element={<Mumbaidarshancabs />} />
<Route path="/pune-to-5-jyotirlinga-cab" element={<Punetofivejyotilinga />} />
<Route path="/viman-nagar-to-mumbai-ertiga-on-rent" element={<Vimannagartomumbaiertigaonrent />} />
<Route path="/pune-outstation-cabs" element={<Puneoutstationcabs />} />

      </Routes>
     <HomeContactAndFooter/>
    </Router>
  );
}



export default App;
